import { queryData } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getProcessor = async (id) => {
  return await queryData(`${GlobalConfig.REACT_APP_API_PROCESSOR_URL}${id}`);
};
